<div class="spinner-overlay">
    <app-spinner></app-spinner>
</div>